export const helpersMethods = [
    {
      dataType: 2, items:[
        {
            appliesTo: 5, 
            title: "Date Difference", 
            content1: "DATEDIFF({INTERVAL}, {START_DATETIME}, {END_DATETIME})", 
            content2: "Returns the difference between two date time values according to the interval that you choose. For example, you can pass YEAR to get the difference in years. Other possible interval values include MONTH, DAY, QUARTER, WEEK, HOUR, MINUTE, SECOND and MILLISECOND.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Day", 
            content1: "DATEPART(DAY, [FIELD])", 
            content2: "Returns the day part of the date time field.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Elapsed Interval", 
            content1: "DATEDIFF({INTERVAL}, {START_DATETIME}, GETDATE())", 
            content2: "Returns the elapsed interval since the specified date according to the interval that you choose. For example, you can pass YEAR to get the elapsed interval in years. Other possible interval values include MONTH, DAY, QUARTER, WEEK, HOUR, MINUTE, SECOND and MILLISECOND.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Elapsed Interval UTC", 
            content1: "DATEDIFF({INTERVAL}, {START_DATETIME}, GETUTCDATE())", 
            content2: "Returns the elapsed interval since the specified date (UTC) according to the interval that you choose. For example, you can pass YEAR to get the elapsed interval in years. Other possible interval values include MONTH, DAY, QUARTER, WEEK, HOUR, MINUTE, SECOND and MILLISECOND.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Hour", 
            content1: "DATEPART(HOUR, [FIELD])", 
            content2: "Returns the hour (24 based) part of the date time field.", 
            ToAdd: ""
        },     
        {
            appliesTo: 5, 
            title: "Millisecond", 
            content1: "DATEPART(MILLISECOND, [FIELD])", 
            content2: "Returns the millisecond part of the date time field.", 
            ToAdd: ""
        },         
        {
            appliesTo: 5, 
            title: "Minute", 
            content1: "DATEPART(MINUTE, [FIELD])", 
            content2: "Returns the minute part of the date time field.", 
            ToAdd: ""
        },          
        {
            appliesTo: 5, 
            title: "Month", 
            content1: "DATEPART(MONTH, [FIELD])", 
            content2: "Returns the month part of the date time field.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Month and Year Number", 
            content1: "CAST(FORMAT([FIELD], 'yyyy') + FORMAT([FIELD], 'MM') AS INT)",
            //content1: "DBO.MONTHYEARNUMBER([FIELD])", 
            content2: "Returns a number reflecting the the month and year. For example, if the value is 2022-4-22, 202204 is returned. This is useful when you group by MonthYearText and you want your data to be sorted.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Quarter", 
            content1: "DATEPART(QUARTER, [FIELD])", 
            content2: "Returns the quarter part of the date time field. Values range from 1 to 4.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Quarter and Year Number", 
            content1: "CAST(FORMAT([FIELD], 'yyyy') + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)) AS INT)",
            //content1: "DBO.QUARTERYEARNUMBER([FIELD])", 
            content2: "Returns a number reflecting the the quarter and year. For example, if the value is 2022-4-22, 20222 is returned. This is useful when you group by QuarterYearText and you want your data to be sorted.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Second", 
            content1: "DATEPART(SECOND, [FIELD])", 
            content2: "Returns the second part of the date time field.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Week", 
            content1: "DATEPART(WEEK, [FIELD])", 
            content2: "Returns the week part of the date time field. Values range from 1 till 53.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Weekday", 
            content1: "DATEPART(WEEKDAY, [FIELD])", 
            content2: "Returns the week day part of the date time field. 1 is returned for Sunday.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Year", 
            content1: "DATEPART(YEAR, [FIELD])", 
            content2: "Returns the year part of the date time field.", 
            ToAdd: ""
        },       



        {
            appliesTo: 4, 
            title: "Date Difference", 
            content1: "DATEDIFF({INTERVAL}, {START_DATE}, {END_DATE})", 
            content2: "Returns the difference between two date values according to the interval that you choose. For example, you can pass YEAR to get the difference in years. Other possible interval values include MONTH, DAY, QUARTER and WEEK.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Day", 
            content1: "DATEPART(DAY, [FIELD])", 
            content2: "Returns the day part of the date field.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Elapsed Interval", 
            content1: "DATEDIFF({INTERVAL}, {START_DATE}, CAST(GETDATE() AS DATE))", 
            content2: "Returns the elapsed interval since the specified date according to the interval that you choose. For example, you can pass YEAR to get the elapsed interval in years. Other possible interval values include MONTH, DAY, QUARTER and WEEK", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Elapsed Interval UTC", 
            content1: "DATEDIFF({INTERVAL}, {START_DATE}, CAST(GETUTCDATE() AS DATE))", 
            content2: "Returns the elapsed interval since the specified date (UTC) according to the interval that you choose. For example, you can pass YEAR to get the elapsed interval in years. Other possible interval values include MONTH, DAY, QUARTER and WEEK", 
            ToAdd: ""
        },       
        {
            appliesTo: 4, 
            title: "Month", 
            content1: "DATEPART(MONTH, [FIELD])", 
            content2: "Returns the month part of the date field.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Month and Year Number", 
            content1: "CAST(FORMAT([FIELD], 'yyyy') + FORMAT([FIELD], 'MM') AS INT)",
            //content1: "DBO.MONTHYEARNUMBER([FIELD])", 
            content2: "Returns a number reflecting the the month and year. For example, if the value is 2022-4-22, 202204 is returned. This is useful when you group by MonthYearText and you want your data to be sorted.", 
            ToAdd: ""
        },        
        {
            appliesTo: 4, 
            title: "Quarter", 
            content1: "DATEPART(QUARTER, [FIELD])", 
            content2: "Returns the quarter part of the date field. Values range from 1 to 4.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Quarter and Year Number", 
            content1: "CAST(FORMAT([FIELD], 'yyyy') + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)) AS INT)",
            //content1: "DBO.QUARTERYEARNUMBER([FIELD])", 
            content2: "Returns a number reflecting the the quarter and year. For example, if the value is 2022-4-22, 20222 is returned. This is useful when you group by QuarterYearText and you want your data to be sorted.", 
            ToAdd: ""
        },          
        {
            appliesTo: 4, 
            title: "Week", 
            content1: "DATEPART(WEEK, [FIELD])", 
            content2: "Returns the week part of the date field. Values range from 1 till 53.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Weekday", 
            content1: "DATEPART(WEEKDAY, [FIELD])", 
            content2: "Returns the week day part of the date field. 1 is returned for Sunday.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Year", 
            content1: "DATEPART(YEAR, [FIELD])", 
            content2: "Returns the year part of the date field.", 
            ToAdd: ""
        }, 
            
            
        {
            appliesTo: 2, 
            title: "Safe Division", 
            content1: "DBO.SAFE_DIVIDE([FIELD1], [FIELD2])", 
            content2: "Returns the result of the division of FIELD1 by FIELD2 (FIELD1/FIELD2). The result is always decimal. When FIELD2 is 0, the result is always Null. When either or both of the two fields is Null, the result is also Null.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Average - Aggregate", 
            content1: "AVG([FIELD])", 
            content2: "Returns the average of the specified field. NULLs are not counted.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Count - Aggregate", 
            content1: "COUNT([FIELD])", 
            content2: "Returns the count of the specified field. NULLs are not counted.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Maximum - Aggregate", 
            content1: "MAX([FIELD])", 
            content2: "Returns the maximum of the specified field.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Minimum - Aggregate", 
            content1: "MIN([FIELD])", 
            content2: "Returns the minimum of the specified field.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Standard Deviation - Aggregate", 
            content1: "STDEV([FIELD])", 
            content2: "Returns the standard deviation of the specified field.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Standard Deviation Population - Aggregate", 
            content1: "STDEVP([FIELD])", 
            content2: "Returns the standard deviation population of the specified field.", 
            ToAdd: ""
        },
        {
            appliesTo: 2, 
            title: "Sum - Aggregate", 
            content1: "SUM([FIELD])", 
            content2: "Returns the sum of the specified field.", 
            ToAdd: ""
        },


        {
            appliesTo: "Text", 
            title: "Count - Aggregate", 
            content1: "COUNT([FIELD])", 
            content2: "Returns the count of the specified field. NULLs are not counted.", 
            ToAdd: ""
        },


        {
            appliesTo: "Boolean", 
            title: "Count - Aggregate", 
            content1: "COUNT([FIELD])", 
            content2: "Returns the count of the specified field. NULLs are not counted.", 
            ToAdd: ""
        }
      ]
    },

    {
      dataType: 3, items:[
        {
            appliesTo: 5, 
            title: "Day Text", 
            content1: "FORMAT([FIELD], {format})",//"DBO.DAYTEXT([FIELD], {FORMAT})", 
            content2: "Returns the day part of the date time field as text. Format determines how the value is returned. For example, if we are on the 1st day of the month and FORMAT is d, 1 is returned. If FORMAT is dd, 01 is returned. If FORMAT is ddd, Tue is returned. If FORMAT is dddd, Tuesday is returned.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Hour", 
            content1: "FORMAT([FIELD], 'hh')", 
            content2: "Returns the hour(24 based) part of the date time field as text.", 
            ToAdd: ""
        }, 
        {
            appliesTo: 5, 
            title: "Millisecond", 
            content1: "FORMAT([FIELD], 'ms')", 
            content2: "Returns the millisecond pqrt of the date time field as text.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Minute", 
            content1: "FORMAT([FIELD], 'mm')", 
            content2: "Returns the minute part of the date time field as text.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Month Text", 
            content1: "FORMAT([FIELD], {format})",// "DBO.MONTHTEXT([FIELD], {FORMAT})", 
            content2: "Returns the month part of the date time field as text. Format determines how the value is returned. For example, if the month is January and FORMAT is 'M', 1 is returned. If FORMAT is 'MM', 01 is returned. If FORMAT is 'MMM', Jan is returned. If FORMAT is 'MMMM', January is returned.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Month Year Text", 
            content1: "(FORMAT([FIELD], {format}) + '-' + FORMAT([FIELD], 'yyyy'))",//"DBO.MONTHYEARTEXT([FIELD], {FORMAT})", 
            content2: "Returns the month and year of the field based on the FORMAT. For example, if the value is 2022-4-22 and FORMAT is 'M', 4-2022 is returned. If FORMAT is 'MM', 04-2022 is returned. If FORMAT is 'MMM', Apr-2022 is returned. April-2022 is returned if 'MMMM'.", 
            ToAdd: ""
        },        
        {
            appliesTo: 5, 
            title: "Quarter Text", 
            content1: "('Q' + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)))",//"DBO.QUARTERTEXT([FIELD], {FORMAT})", 
            content2: "Returns the quarter part of the date time field as text. The first quarter for instance is returned as Q1.", 
            ToAdd: ""
        },     
        {
            appliesTo: 5, 
            title: "Quarter Year Text", 
            content1: "('Q' + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)) + '-' + FORMAT([FIELD], 'yyyy'))",//"DBO.QUARTERYEARTEXT([FIELD], {FORMAT})", 
            content2: "Returns the quarter and year of the field. For example Q2-2022 is returned for the second quarter of year 2022.", 
            ToAdd: ""
        },   
        {
            appliesTo: 5, 
            title: "Second", 
            content1: "FORMAT([FIELD], 'ss')", 
            content2: "Returns the second part of the date time field as text.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Week Text", 
            content1: "('W' + CAST(DATEPART(WEEK, [FIELD]) AS VARCHAR(2)))",//"DBO.WEEKTEXT([FIELD], {FORMAT})", 
            content2: "Returns the week part of the date time field as text. For example, if we are in the third week of the year W3 is returned.", 
            ToAdd: ""
        },
        {
            appliesTo: 5, 
            title: "Year", 
            content1: "format([FIELD], 'yyyy')", 
            content2: "Returns the year part of the date time field as text.", 
            ToAdd: ""
        },


        {
            appliesTo: 4, 
            title: "Day Text", 
            content1: "FORMAT([FIELD], {format})",//"DBO.DAYTEXT([FIELD], {FORMAT})", 
            content2: "Returns the day part of the date field as text. Format determines how the value is returned. For example, if we are on the 1st day of the month and FORMAT is d, 1 is returned. If FORMAT is dd, 01 is returned. If FORMAT is ddd, Tue is returned. If FORMAT is dddd, Tuesday is returned.", 
            ToAdd: ""
        },        
        {
            appliesTo: 4, 
            title: "Quarter Text", 
            content1: "('Q' + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)))",//"DBO.QUARTERTEXT([FIELD], {FORMAT})", 
            content2: "Returns the quarter part of the date field as text. The first quarter for instance is returned as Q1.", 
            ToAdd: ""
        },
        {
            appliesTo: 4, 
            title: "Quarter Year Text", 
            content1: "('Q' + CAST(DATEPART(QUARTER, [FIELD]) AS CHAR(1)) + '-' + FORMAT([FIELD], 'yyyy'))",//"DBO.QUARTERYEARTEXT([FIELD], {FORMAT})", 
            content2: "Returns the quarter and year of the field. For example, Q2-2,022 is returned for the second quarter of year 2022.", 
            ToAdd: ""
        },         
        {
            appliesTo: 4, 
            title: "Month Text", 
            content1: "FORMAT([FIELD], {format})",// "DBO.MONTHTEXT([FIELD], {FORMAT})", 
            content2: "Returns the month part of the date time field as text. Format determines how the value is returned. For example, if the month is January and FORMAT is 'M', 1 is returned. If FORMAT is 'MM', 01 is returned. If FORMAT is 'MMM', Jan is returned. If FORMAT is 'MMMM', January is returned.", 
            ToAdd: ""
        },    
        {
            appliesTo: 4, 
            title: "Month Year Text", 
            content1: "(FORMAT([FIELD], {format}) + '-' + FORMAT([FIELD], 'yyyy'))",//"DBO.MONTHYEARTEXT([FIELD], {FORMAT})", 
            content2: "Returns the month and year of the field based on the FORMAT. For example, if the value is 2022-4-22 and FORMAT is 'M', 4-2022 is returned. If FORMAT is 'MM', 04-2022 is returned. If FORMAT is 'MMM', Apr-2022 is returned. April-2022 is returned if 'MMMM'.", 
            ToAdd: ""
        },  
        {
            appliesTo: 4, 
            title: "Week Text", 
            content1: "('W' + CAST(DATEPART(WEEK, [FIELD]) AS VARCHAR(2)))",//"DBO.WEEKTEXT([FIELD], {FORMAT})", 
            content2: "Returns the week part of the date time field as text. For example, if we are in the third week of the year W3 is returned.", 
            ToAdd: ""
        },        
        {
            appliesTo: 4, 
            title: "Year", 
            content1: "format([FIELD], 'yyyy')", 
            content2: "Returns the year part of the date field as text.", 
            ToAdd: ""
        },        
             
      ]
    },

    {
        dataType: 4, items:[
          {
            appliesTo: 4, 
            title: "Maximum", 
            content1: "MAX([FIELD])", 
            content2: "Returns the maximum of the date field.", 
            ToAdd: ""
          },
          {
            appliesTo: 4, 
            title: "Minimum", 
            content1: "MIN([FIELD])", 
            content2: "Returns the minimum of the date field.", 
            ToAdd: ""
          },
          {
            appliesTo: 4, 
            title: "Today", 
            content1: "CAST(GETDATE() AS DATE)", 
            content2: "Returns the current date.", 
            ToAdd: ""
          },
          {
            appliesTo: 4, 
            title: "Today UTC", 
            content1: "CAST(GETUTCDATE() AS DATE)", 
            content2: "Returns the current date UTC.", 
            ToAdd: ""
          },
          
          
          {
            appliesTo: 5, 
            title: "Date From DateTime", 
            content1: "CAST([FIELD] AS DATE)", 
            content2: "Returns the date part of the date time field.", 
            ToAdd: ""
          },          
          {
            appliesTo: 5, 
            title: "Maximum", 
            content1: "CAST(MAX([FIELD]) AS DATE)", 
            content2: "Returns the maximum of the date time field.", 
            ToAdd: ""
          },
          {
            appliesTo: 5, 
            title: "Minimum", 
            content1: "CAST(MIN([FIELD]) AS DATE)", 
            content2: "Returns the minimum of the date time field.", 
            ToAdd: ""
          }
        ]
    },

    {
        dataType: 5, items:[
          {
            appliesTo: 5, 
            title: "Maximum", 
            content1: "MAX([FIELD])", 
            content2: "Returns the maximum of the date time field.", 
            ToAdd: ""
          },
          {
            appliesTo: 5, 
            title: "Minimum", 
            content1: "MIN([FIELD])", 
            content2: "Returns the minimum of the date time field.", 
            ToAdd: ""
          },
          {
            appliesTo: 5, 
            title: "Now", 
            content1: "GETDATE()", 
            content2: "Returns the current date time.", 
            ToAdd: ""
          },
          {
            appliesTo: 5, 
            title: "Now UTC", 
            content1: "GETUTCDATE()", 
            content2: "Returns the current date time UTC.", 
            ToAdd: ""
          },
          {
            appliesTo: 5,
            title: "Date Bucket",
            content1: "DATE_BUCKET([PERIOD], 2, [DATETIMEFIELD])",
            content2: "Combines the date periods into segments based on the first 2 parameters; PERIOD can be MINUTE or HOUR.", 
          }
        ]
    }
  ];